import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function AboutPage() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main className="flex-1 pt-20">
        <nav className="w-full max-w-7xl mx-auto px-4 md:px-6 lg:px-8 py-4" aria-label="面包屑导航">
          <ol className="flex items-center gap-1.5 text-sm text-foreground-500">
            <li><Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">首页</Link></li>
            <li><i className="ri-arrow-right-s-line text-xs"></i></li>
            <li className="text-foreground-800 font-medium">关于我们</li>
          </ol>
        </nav>

        <section className="w-full max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
          <div className="text-center py-10 md:py-14">
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">关于韩漫在线</h1>
            <p className="text-base text-foreground-500 max-w-2xl mx-auto leading-relaxed">
              韩漫在线是领先的韩国漫画免费在线阅读平台，致力于为全球中文读者提供最优质、最全面的韩漫阅读体验。
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 pb-10">
            {[
              { icon: 'ri-book-2-line', label: '漫画资源', value: '10,000+' },
              { icon: 'ri-user-star-line', label: '月活读者', value: '500万+' },
              { icon: 'ri-timer-line', label: '每日更新', value: '50+部' },
              { icon: 'ri-shield-check-line', label: '安全阅读', value: '100%免费' },
            ].map((stat) => (
              <div key={stat.label} className="bg-background-100 rounded-lg p-5 md:p-6 text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100">
                  <i className={`${stat.icon} text-xl text-primary-500`}></i>
                </div>
                <div className="text-2xl md:text-3xl font-bold text-foreground-900 mb-1">{stat.value}</div>
                <div className="text-sm text-foreground-500">{stat.label}</div>
              </div>
            ))}
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-100">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
              <div>
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-5">我们的品牌故事</h2>
                <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
                  <p>
                    韩漫在线成立于2020年，由一群热爱韩国漫画的年轻人创立。我们深知韩国漫画在全球范围内的巨大影响力，也理解中文读者对于高质量韩漫阅读体验的渴望。
                  </p>
                  <p>
                    作为免费韩漫在线阅读平台，我们与多家韩国漫画出版社建立了合作关系，确保第一时间为读者带来最新、最热的韩漫资源。从热门连载到经典完结，从恋爱甜宠到奇幻冒险，我们拥有最全面的韩漫画库。
                  </p>
                  <p>
                    我们秉持<strong>"让每一位读者都能免费享受韩漫乐趣"</strong>的理念，始终坚持免费运营模式。通过广告收入维持平台运转，绝不向读者收取任何费用。无论是韩漫免费看全集还是韩漫在线免费阅读，我们都竭诚为您服务。
                  </p>
                  <p>
                    截至目前，韩漫在线已服务超过500万月活跃读者，日均页面浏览量突破千万。我们持续优化阅读体验，提供流畅的在线阅读、便捷的收藏功能和个性化的推荐系统。
                  </p>
                </div>
              </div>
              <div className="relative aspect-[4/3] rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20modern%20creative%20workspace%20with%20digital%20artists%20working%20on%20illustrations%2C%20warm%20coral%20accent%20walls%2C%20large%20monitors%20displaying%20webtoon%20art%2C%20cozy%20atmosphere%20with%20plants%20and%20ambient%20lighting%2C%20clean%20minimalist%20office%20design%2C%20professional%20yet%20relaxed%20vibe&width=800&height=600&seq=about-brand-01&orientation=landscape"
                  alt="韩漫在线团队工作场景"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-50">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
            <div className="text-center mb-10">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">我们的优势</h2>
              <p className="text-sm text-foreground-500 max-w-xl mx-auto">选择韩漫在线，享受最优质的韩漫免费阅读体验</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {[
                {
                  icon: 'ri-database-2-line',
                  title: '海量漫画资源',
                  desc: '收录超过10,000部韩国漫画作品，涵盖恋爱、奇幻、动作、搞笑、悬疑等全部热门分类，每日50+部作品同步更新。',
                },
                {
                  icon: 'ri-smartphone-line',
                  title: '多端畅读体验',
                  desc: '完美适配电脑、平板和手机端，随时随地畅享韩漫在线阅读。流畅的纵向滚动阅读模式，沉浸式阅读体验。',
                },
                {
                  icon: 'ri-secure-payment-line',
                  title: '完全免费',
                  desc: '韩漫在线所有漫画资源完全免费，无需任何付费即可畅读全部章节。韩漫免费看全集，无隐藏收费。',
                },
                {
                  icon: 'ri-speed-up-line',
                  title: '极速加载',
                  desc: '采用先进的CDN加速技术，确保漫画页面秒开。高清画质与快速加载兼得，告别等待焦虑。',
                },
                {
                  icon: 'ri-user-smile-line',
                  title: '贴心服务',
                  desc: '个性化推荐、智能收藏、阅读历史、更新提醒等功能，让您的韩漫阅读之旅更加便捷愉快。',
                },
                {
                  icon: 'ri-shield-star-line',
                  title: '正版合作',
                  desc: '与韩国主流漫画平台建立合作关系，确保内容来源的正规性和更新及时性，为读者提供可靠的阅读保障。',
                },
              ].map((item) => (
                <div key={item.title} className="bg-background-100 rounded-lg p-5 md:p-6">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 mb-4">
                    <i className={`${item.icon} text-lg text-accent-600`}></i>
                  </div>
                  <h3 className="font-heading text-base font-bold text-foreground-800 mb-2">{item.title}</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-100">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-8">常见问题</h2>
            <div className="max-w-3xl mx-auto space-y-3">
              {[
                { q: '韩漫在线真的完全免费吗？', a: '是的！韩漫在线所有漫画资源完全免费，无需支付任何费用即可畅读所有章节。我们通过广告收入维持平台运营，始终坚守免费承诺。' },
                { q: '如何找到我想看的韩漫？', a: '您可以通过首页的分类导航按类型浏览，也可以使用顶部搜索框直接搜索漫画名称。我们还提供热门推荐和个性化推荐功能，帮助您发现更多感兴趣的韩漫。' },
                { q: '韩漫在线每日更新多少部漫画？', a: '我们每日更新超过50部漫画，涵盖各类热门连载和最新完结作品。您可以在首页的"最新更新"区域查看当天更新的全部漫画。' },
                { q: '支持手机阅读吗？', a: '当然支持！韩漫在线完美适配手机、平板和电脑端，您可以在任何设备上流畅阅读。我们采用响应式设计，自动适应不同屏幕尺寸。' },
                { q: '漫画内容是否为正版？', a: '韩漫在线与多家韩国漫画出版社建立了合作关系，确保平台上的漫画内容来源正规、更新及时，为读者提供可靠的阅读保障。' },
              ].map((faq, idx) => (
                <FAQItem key={idx} question={faq.q} answer={faq.a} />
              ))}
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14 bg-background-50">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
            <div className="max-w-2xl mx-auto">
              <div className="text-center mb-8">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">联系我们</h2>
                <p className="text-sm text-foreground-500">有任何问题或建议？欢迎随时联系我们</p>
              </div>
              <div className="bg-background-100 rounded-lg p-6 md:p-8">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 shrink-0">
                      <i className="ri-mail-line text-primary-500"></i>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-700 mb-0.5">电子邮箱</div>
                      <div className="text-sm text-foreground-500">contact@hanmantv.com</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-100 shrink-0">
                      <i className="ri-customer-service-line text-accent-600"></i>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-700 mb-0.5">在线客服</div>
                      <div className="text-sm text-foreground-500">工作日 9:00 - 18:00</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-secondary-100 shrink-0">
                      <i className="ri-question-answer-line text-secondary-600"></i>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-700 mb-0.5">商务合作</div>
                      <div className="text-sm text-foreground-500">biz@hanmantv.com</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100 shrink-0">
                      <i className="ri-wechat-line text-primary-500"></i>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-700 mb-0.5">官方微信</div>
                      <div className="text-sm text-foreground-500">hanmantv_official</div>
                    </div>
                  </div>
                </div>
                <ContactForm />
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />

      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'AboutPage',
        name: '关于韩漫在线 - 免费韩漫在线阅读平台',
        description: '韩漫在线是领先的韩国漫画免费在线阅读平台，致力于为全球中文读者提供最优质、最全面的韩漫阅读体验。',
        url: 'https://www.hanmantv.com/about',
        mainEntity: {
          '@type': 'Organization',
          name: '韩漫在线',
          url: 'https://www.hanmantv.com',
          description: '韩漫在线提供韩漫免费在线观看服务。',
        },
      }) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: [
          { '@type': 'Question', name: '韩漫在线真的完全免费吗？', acceptedAnswer: { '@type': 'Answer', text: '是的！韩漫在线所有漫画资源完全免费，无需支付任何费用即可畅读所有章节。' } },
          { '@type': 'Question', name: '如何找到我想看的韩漫？', acceptedAnswer: { '@type': 'Answer', text: '您可以通过首页的分类导航按类型浏览，也可以使用顶部搜索框直接搜索漫画名称。' } },
          { '@type': 'Question', name: '韩漫在线每日更新多少部漫画？', acceptedAnswer: { '@type': 'Answer', text: '我们每日更新超过50部漫画，涵盖各类热门连载和最新完结作品。' } },
          { '@type': 'Question', name: '支持手机阅读吗？', acceptedAnswer: { '@type': 'Answer', text: '当然支持！韩漫在线完美适配手机、平板和电脑端，您可以在任何设备上流畅阅读。' } },
          { '@type': 'Question', name: '漫画内容是否为正版？', acceptedAnswer: { '@type': 'Answer', text: '韩漫在线与多家韩国漫画出版社建立了合作关系，确保平台上的漫画内容来源正规。' } },
        ],
      }) }} />
    </div>
  );
}

function FAQItem({ question, answer }: { question: string; answer: string }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="bg-background-50 rounded-lg overflow-hidden">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
      >
        <span className="text-sm font-medium text-foreground-700 pr-4">{question}</span>
        <i className={`ri-arrow-down-s-line text-foreground-400 transition-transform duration-200 ${open ? 'rotate-180' : ''}`}></i>
      </button>
      {open && (
        <div className="px-5 pb-4 text-sm text-foreground-500 leading-relaxed">{answer}</div>
      )}
    </div>
  );
}

function ContactForm() {
  const [formState, setFormState] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('website_alt') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setFormState('success');
      form.reset();
      setTimeout(() => setFormState('idle'), 3000);
      return;
    }
    setFormState('loading');
    setFormError('');
    try {
      const formData = new FormData(form);
      const formUrl = 'https://readdy.ai/api/form/d9opfjosenbniolesjcg';
      const res = await fetch(formUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const text = await res.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(text); } catch { /* noop */ }
      const code = (parsed as { code?: string }).code;
      if (res.ok && code === 'OK') {
        setFormState('success');
        form.reset();
        setTimeout(() => setFormState('idle'), 3000);
      } else {
        const msg = (parsed as { meta?: { message?: string; detail?: string }; message?: string }).meta?.message
          || (parsed as { meta?: { message?: string; detail?: string }; message?: string }).message
          || (parsed as { meta?: { message?: string; detail?: string } }).meta?.detail
          || text;
        setFormError(typeof msg === 'string' ? msg : '提交失败，请稍后再试');
        setFormState('error');
      }
    } catch {
      setFormError('网络错误，请稍后重试');
      setFormState('error');
    }
  };

  return (
    <form onSubmit={handleSubmit} data-readdy-form="">
      <div className="space-y-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-foreground-600 mb-1.5">姓名</label>
            <input
              type="text"
              name="name"
              required
              className="w-full px-3.5 py-2.5 rounded-lg bg-background-50 border border-background-300 text-sm text-foreground-800 outline-none focus:border-primary-400 transition-colors"
              placeholder="请输入您的姓名"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-foreground-600 mb-1.5">邮箱</label>
            <input
              type="email"
              name="email"
              required
              className="w-full px-3.5 py-2.5 rounded-lg bg-background-50 border border-background-300 text-sm text-foreground-800 outline-none focus:border-primary-400 transition-colors"
              placeholder="请输入您的邮箱"
            />
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium text-foreground-600 mb-1.5">主题</label>
          <input
            type="text"
            name="subject"
            required
            className="w-full px-3.5 py-2.5 rounded-lg bg-background-50 border border-background-300 text-sm text-foreground-800 outline-none focus:border-primary-400 transition-colors"
            placeholder="请输入主题"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-foreground-600 mb-1.5">留言内容</label>
          <textarea
            name="message"
            required
            maxLength={500}
            rows={4}
            className="w-full px-3.5 py-2.5 rounded-lg bg-background-50 border border-background-300 text-sm text-foreground-800 outline-none focus:border-primary-400 transition-colors resize-none"
            placeholder="请输入您的留言（500字以内）"
          ></textarea>
        </div>
        <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly className="honeypot-field" />
        <button
          type="submit"
          disabled={formState === 'loading'}
          className="w-full px-6 py-3 bg-primary-500 hover:bg-primary-600 disabled:opacity-60 text-background-50 dark:text-foreground-950 font-medium rounded-full text-sm whitespace-nowrap transition-colors cursor-pointer"
        >
          {formState === 'loading' ? '提交中...' : '发送留言'}
        </button>
        {formState === 'success' && (
          <p className="text-sm text-accent-600 text-center">留言已发送，我们会尽快回复您！</p>
        )}
        {formState === 'error' && formError && (
          <p className="text-sm text-red-500 text-center">{formError}</p>
        )}
      </div>
    </form>
  );
}